<header class="title">
  @if (sectionName(); as section) {
    <span class="title-eyebrow">{{ section }}</span>
  }

  <div class="title-row">
    <h2 class="title-heading">
      @if (displayNumber()) {
        <span class="title-number">{{ displayNumber() }}</span>
      }
      {{ itemTitle() ?? 'Request item' }}
    </h2>
  </div>
</header>
